import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type CompanyModel from 'garaje/models/company';
import type LocationModel from 'garaje/models/location';
import type PrinterConnectionModel from 'garaje/models/printer-connection';
import type UserModel from 'garaje/models/user';
import type ZoneModel from 'garaje/models/zone';

export default class PrinterPasscode extends Model {
  @attr('string')
  declare code: string;

  @attr('boolean', { defaultValue: false })
  declare factoryRecord: boolean;

  @attr('date')
  declare consumedAt: Date;

  @attr('date')
  declare expiresAt: Date;

  @attr('date')
  declare createdAt: Date;

  @belongsTo('company', { async: true, inverse: null })
  declare company: AsyncBelongsTo<CompanyModel>;

  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;

  @belongsTo('user', { async: true, inverse: null })
  declare user: AsyncBelongsTo<UserModel>;

  @belongsTo('zone', { async: true, inverse: null })
  declare zone: AsyncBelongsTo<ZoneModel>;

  @belongsTo('printer-connection', { async: false, inverse: null })
  declare printerConnection: PrinterConnectionModel;

  get printerConnectionId(): string | null {
    const record = this as PrinterPasscode;

    return record.belongsTo('printerConnection').id();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'printer-passcode': PrinterPasscode;
  }
}
